import React,{useState} from 'react'
import Carousel, { consts } from 'react-elastic-carousel'
import Item from '../Item';
import ImageSlider from './ImageSlider';
import { useNavigate } from 'react-router-dom';

function ProjectDetails() {
  let review = [1, 2, 3, 4]
  let heads = ["Overview", "Curriculam", "Session", "Reviews", "Screenshots"]
  let b2c_services_res = [1, 2, 3]
  const navigate = useNavigate();

  function myArrow({ type, onClick, isEdge }) {
    const pointer = type === consts.PREV ? 'back' : 'forward'
    const btn = <ion-icon name={`arrow-${pointer}-outline`} style={{ color: "#dddddd", fontSize: "35px" }} ></ion-icon>
    return (

      <button style={{ display: "none", background: "none", position: "absolute", top: "5%", zIndex: "2" }} className={type === consts.PREV ? "start-0" : "end-0"} onClick={onClick} disabled={isEdge}>
        {btn}
      </button>
    )
  }

  function renderPagination({ pages, activePage, onClick }) {

    return (
      <div className="d-flex justify-content-evenly border border-secondary rounded purple darken-4 align-items-end b2c-nav">
        {pages.map((page, index) => {
          const isActivePage = activePage === page
          return (
            <div
              key={page}
              onClick={() =>
                onClick(page)
              } style={{ color: `${isActivePage ? "whitesmoke" : "grey"}`, cursor: "pointer", transition: ".5s", borderBottom: `${isActivePage ? "2px solid grey" : ""}` }}
              active={isActivePage} className=' h4 b2c-service px-4'>{window.innerWidth >= 1000 ? heads[index] : b2c_services_res[index]} </div>
          )
        })}
      </div>
    )
  }
  const [fixContainer, setfixContainer] = useState(false)

  let handleClick=(event)=>{
    event.stopPropagation()
    navigate("/internationalProjects/project/Payment")
  }
  window.addEventListener("scroll", () => {
    let y = window.scrollY
    let div = document.querySelector('.maindiv')
    console.log(y);
    if (y > 300) {
        setfixContainer(true)
    }
    if (y < 200) {
        setfixContainer(false)
    }
    if (y >= (div.offset().top + div.outerHeight() - window.innerHeight)) {
        setfixContainer(false)
    }
})

  return (
    <div style={{ marginTop: "13%" }}>
      <div className="row flex-row-reverse w-100">
        <div className="col-md-3">
          <div className="p-3 white-3">
          <div className={`position-${fixContainer && "fixed py-5 pr-4  h-75"}  `} style={{ bottom: '15%', transition: ".5s" }}>
                        <div className="d-flex flex-column rounded p-3" style={{ backgroundColor: '#1A1A40', height: 'auto' }}>
                            <div className="my-2 d-flex justify-content-between">
                                <h3 className="white-2">Price</h3>
                                <h4 style={{textDecoration:"line-through"}}>INR 3500</h4>
                            </div>
                            <div className="my-2 d-flex justify-content-between">
                                <h4 className="white-3">save 15%</h4>
                                <h3>INR 3000</h3>
                            </div>
                            <a className="btn w-100  letter-dis-2  align-self-center" style={{ background: "#E65100" }} onClick={handleClick} >Buy now</a>
                        </div>
                        </div>
          </div>
        </div>
        <div className="col-md-7 white-2">
          <div className="d-flex"></div>
          <div className="d-flex justify-content-evenly">
            <img className="rounded  w-50  p-2 mb-2 border border-info" src={require('../../resource/global.webp')} alt="" />
            <div className="align-self-center">
              <div className=" py-1 m-1 ">
                <ion-icon name="share-outline" style={{ fontSize: "26px", cursor: "pointer" }}></ion-icon>
                <ion-icon name="heart-outline" style={{ fontSize: "26px", cursor: "pointer" }}></ion-icon>
                <ion-icon name="caret-down-outline" style={{ fontSize: "26px", cursor: "pointer" }}></ion-icon>
              </div>
              <p className="white-2">17 Enrolled</p>
              <p className="white-2">35 Completed</p>
              <div className="review mt-3 white-3 " style={{ whiteSpace: "nowrap" }}>
                <ion-icon name="star" style={{ color: "#FFA500", fontSize: "18px" }}></ion-icon>
                <ion-icon name="star" style={{ color: "#FFA500", fontSize: "18px" }}></ion-icon>
                <ion-icon name="star" style={{ color: "#FFA500", fontSize: "18px" }}></ion-icon>
                <ion-icon name="star" style={{ color: "#FFA500", fontSize: "18px" }}></ion-icon>
                <ion-icon name="star-half-outline" style={{ color: "#FFA500", fontSize: "18px" }}></ion-icon>
                &#160;4.5
              </div>
            </div>
          </div>
          <h3 className="light-blue-text">Remote Farming: An smart and advance way of farming</h3>
          <Carousel
            itemsToShow={1}
            itemsToScroll={1}
            easing="cubic-bezier(.1,1.34,.86,1.07)"
            tiltEasing="cubic-bezier(0.110, 1, 1.000, 0.210)"
            transitionMs={800}
            className={`${window.innerWidth > 750 && "container"} position-relative`}
            renderArrow={myArrow}
            renderPagination={renderPagination}
          >
            <Item >
              <div className="white-3 mt-5 pt-3">
                <h3 className=" white-2">Overview</h3>
                <p>Due to the severe climate changes occurring in the India, an IOT solution for weather forecast (especially for the farms in India) was thought in order to prevent any further failure in crop production due to climate change problems. The following research paper will be discussing the chosen solution. In this project we will be building an Internet of Things (IoT) Weather Station using Hortonworks Connected Data Architecture, which incorporates open source frameworks. Finally as a result we will obtain the graph between “time vs temperature”, time vs pressure”, and “time vs humidity” which helps us to predict the weather conditions like rainy, sunny, cloudy, clear, fair etc. (at the farms) that definitely helps people and farmers to increase their crops productivity using such weather information regarding weather conditions”. Keywords: Physical layer, database layer, presentation layer, HDF, HDP, NIFI, MiNiFi .</p>
                <h3 className="white-2">Indicative Assessment</h3>
                <p>After every session student will get the assignment based on the following subjects as given below:</p>
                <ul>
                  <li>Working of Raspberry Pi and Sensor hat including some question.</li>
                  <li>Install of all the software with screenshot. .</li>
                  <li>Connection of all three layers. </li>
                  <li>configuration of Nifi and Mini Nifi with CDA including python code. </li>
                  <li>Results of all parameters with respect to time in form of graph.</li>

                </ul>

                <h3 className="white-2">Milestones/Workload</h3>
                <p>
                  Prerequisite you should know have like basic knowledge of Python language, docker, virtual box, zeppelin, phoenix, Raspberry pi sensor hat etc. If you don't know about it don't worry just look into all this on internet before you start this project with me.</p>
                <p>There will be no too much workload, just attend sessions and do you home work. And make sure you should submit all the assignment on time.</p>
                <ol>
                  <li>Submission of assignment.</li>
                  <li>Proper presentation and project report presentation.</li>
                  <li>Working knowledge of project.</li>
                </ol>

                <h3 className="white-2">Learning outcomes and student Eligibility</h3>
                <ol>
                  <li> Student of computer science engineering, electrical engineering, IT engineering.</li>
                  <li> Student of BCA (Bachelors in computer application) and MCA (masters in computer application)</li>
                  <li>Any other student who wish to work in IOT and agriculture etc.</li>
                </ol>
              </div>
            </Item>
            <Item>
              <div className="pt-3 mt-5">
                <p className="white-3">
                  No Data Available
                </p>
              </div>
            </Item>
            <Item>
              <div className="pt-3 mt-5">
                <div className="mb-3 border border-secondary rounded">
                  <h4 className="white-2 p-2 stylish-color-dark">Session 1</h4>
                  <p className="p-3 white-3">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Laboriosam quos expedita harum dolorum perspiciatis maiores at assumenda earum provident autem.</p>
                </div>
                <div className="mb-3 border border-secondary rounded">
                  <h4 className="white-2 p-2 stylish-color-dark">Session 2</h4>
                  <p className="p-3 white-3">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Laboriosam quos expedita harum dolorum perspiciatis maiores at assumenda earum provident autem.</p>
                </div>
                <div className="mb-3 border border-secondary rounded">
                  <h4 className="white-2 p-2 stylish-color-dark">Session 3</h4>
                  <p className="p-3 white-3">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Laboriosam quos expedita harum dolorum perspiciatis maiores at assumenda earum provident autem.</p>
                </div>
                <div className="mb-3 border border-secondary rounded">
                  <h4 className="white-2 p-2 stylish-color-dark">Session 4</h4>
                  <p className="p-3 white-3">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Laboriosam quos expedita harum dolorum perspiciatis maiores at assumenda earum provident autem.</p>
                </div>
                <div className="mb-3 border border-secondary rounded">
                  <h4 className="white-2 p-2 stylish-color-dark">Session 5</h4>
                  <p className="p-3 white-3">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Laboriosam quos expedita harum dolorum perspiciatis maiores at assumenda earum provident autem.</p>
                </div>
                <div className="mb-3 border border-secondary rounded">
                  <h4 className="white-2 p-2 stylish-color-dark">Session 6</h4>
                  <p className="p-3 white-3">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Laboriosam quos expedita harum dolorum perspiciatis maiores at assumenda earum provident autem.</p>
                </div>
              </div>
            </Item>
            <Item>
              <div className="pt-3 mt-5">
                {review.map((rev) => {
                  return <div className="co p-3 rounded m-3 deep-purple darken-4 shadow">
                    <div className="d-flex justify-content-between  align-items-end">
                      <div>
                        <img src={require(`../../resource/avater.png`)} width="60" height="60" className="p-1 mb-1 rounded-circle" style={{ background: "grey" }} alt="" />
                        <h5>Anita kumari</h5>
                      </div>
                      <div className="review white-3 " style={{ whiteSpace: "nowrap" }}>
                        <ion-icon name="star" style={{ color: "#FFA500", fontSize: "18px" }}></ion-icon>
                        <ion-icon name="star" style={{ color: "#FFA500", fontSize: "18px" }}></ion-icon>
                        <ion-icon name="star" style={{ color: "#FFA500", fontSize: "18px" }}></ion-icon>
                        <ion-icon name="star-half-outline" style={{ color: "#FFA500", fontSize: "18px" }}></ion-icon>
                        <ion-icon name="star-outline" style={{ color: "#FFA500", fontSize: "18px" }}></ion-icon>
                        &#160;
                      </div>

                    </div>
                    <i className="white-3" >
                      " Lorem ipsum, dolor sit amet consectetur adipisicing elit. Vero animi saepe pariatur beatae assumenda dolore reiciendis, eos omnis modi sunt tempore non. Rem, provident praesentium id, possimus, quisquam beatae cumque quis vero est saepe repudiandae? "
                    </i>
                  </div>

                })}
              </div>
            </Item>
            <Item>
              <div id="carouselExampleControls" class="carousel slide mt-5 pt-3" data-ride="carousel">
                <div class="carousel-inner">
                  <div class="carousel-item active">
                    <img class="d-block w-100" src="https://mdbootstrap.com/img/Photos/Slides/img%20(45).webp"
                      alt="First slide" />
                  </div>
                  <div class="carousel-item">
                    <img class="d-block w-100" src="https://mdbootstrap.com/img/Photos/Slides/img%20(46).webp"
                      alt="Second slide" />
                  </div>
                  <div class="carousel-item">
                    <img class="d-block w-100" src="https://mdbootstrap.com/img/Photos/Slides/img%20(47).webp"
                      alt="Third slide" />
                  </div>
                </div>
                <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
                  <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                  <span class="sr-only">Previous</span>
                </a>
                <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
                  <span class="carousel-control-next-icon" aria-hidden="true"></span>
                  <span class="sr-only">Next</span>
                </a>
              </div>
            </Item>
          </Carousel>
        </div>
      </div>
    </div>
  )
}

export default ProjectDetails